export default __webpack_public_path__ + "static/media/cook2.4a98f57d.PNG";